import React, {ReactNode} from 'react'
import tw from 'tailwind-styled-components'
import {TablerIcons} from '@components/common/icon-tabler/icon-tabler'
import {Padding} from '../design-system/types'
import {Icon} from '../icon'

export interface Props {
  title: ReactNode
  icon?: TablerIcons
  paddings?: Padding
}

export const TwHeader = tw.div<{$paddings: Padding}>`
  h-56
  h1-semibold
  text-primary

  flex
  items-center
  gap-8
  flex-none
  mb-8
  cursor-default

  ${p => getPaddings(p.$paddings)}
`

const getIconSize = (paddings: Padding) => {
  if (paddings === 12) {
    return 16
  }
  return 24
}

export const getPaddings = (paddings: Padding) => {
  if (paddings === 12) {
    return 'px-12'
  }
  return 'px-12'
}

export const PopupHeader = ({icon, title, paddings = 12}: Props) => {
  const iconSize = getIconSize(paddings)

  return (
    <TwHeader $paddings={paddings}>
      {icon && <Icon icon={icon} size={iconSize} color="secondary" />}
      <div className="truncate flex-grow">{title}</div>
    </TwHeader>
  )
}
